module.exports = __webpack_public_path__ + "img/grid-3x2-gap.7b944bdb.svg";